import { DatesRangeValue } from '@mantine/dates';
import { DatePickerInput } from 'src/design/atoms/DatePickerInput';
import React from 'react';

export interface IDateRangeFilterProps {
  value: DatesRangeValue;
  onChange: (value: DatesRangeValue) => void;
}

export const DateRangeFilter: React.FC<IDateRangeFilterProps> = ({
  value,
  onChange,
}) => {
  return (
    <DatePickerInput
      type="range"
      label="Date Range"
      value={value}
      onChange={onChange}
      maxDate={new Date()}
      w={280}
    />
  );
};
